"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REJECT_REASON_LABEL = exports.REJECT_REASONS = exports.STAGES = exports.CATEGORY_LABEL = exports.CATEGORY_LABEL_BY_LOCALE = exports.CATEGORY_PATH = exports.CATEGORIES = void 0;
exports.categoryLabel = categoryLabel;
exports.slugify = slugify;
exports.postPath = postPath;
exports.localePath = localePath;
exports.switchLocalePath = switchLocalePath;
__exportStar(require("./i18n"), exports);
// Re-exporting does not bring these into local scope, so import them too.
const i18n_1 = require("./i18n");
/**
 * Shared contracts between the NestJS API and the Next.js site.
 * Types only — no runtime dependencies, no logic beyond small pure helpers.
 */
// ---------------------------------------------------------------- categories
exports.CATEGORIES = ['news', 'tool', 'update', 'model', 'pricing', 'research'];
/** URL segment for each category. Drives /models/[slug], /api-pricing, etc. */
exports.CATEGORY_PATH = {
    news: 'news',
    tool: 'tools',
    update: 'updates',
    model: 'models',
    pricing: 'pricing',
    research: 'research',
};
/**
 * Category names per locale.
 *
 * Hand-written, not machine translated: a mistranslated category label
 * appears on every card and is more damaging than a slightly stiff story
 * summary.
 */
exports.CATEGORY_LABEL_BY_LOCALE = {
    en: {
        news: 'AI News',
        tool: 'New Tool',
        update: 'Product Update',
        model: 'New Model',
        pricing: 'Pricing & API',
        research: 'Research',
    },
    ar: {
        news: 'أخبار',
        tool: 'أداة جديدة',
        update: 'تحديث',
        model: 'نموذج جديد',
        pricing: 'الأسعار والواجهات',
        research: 'بحث',
    },
};
/** English labels, kept for code that has no locale in scope. */
exports.CATEGORY_LABEL = exports.CATEGORY_LABEL_BY_LOCALE.en;
function categoryLabel(category, locale) {
    return exports.CATEGORY_LABEL_BY_LOCALE[locale][category];
}
// ------------------------------------------------------------------ pipeline
/** Where an item currently sits in the pipeline. */
exports.STAGES = [
    'fetched',
    'prefiltered',
    'triaged',
    'clustered',
    'written',
    'verified',
    'published',
    'rejected',
];
/**
 * Why an item was dropped. Every rejection must carry one of these so the
 * "why we didn't publish" admin view can explain itself.
 */
exports.REJECT_REASONS = [
    'seen_url',
    'republished',
    'source_disabled',
    'stale',
    'listicle',
    'off_topic',
    'duplicate_event',
    'low_importance',
    'marketing',
    'unverified_claims',
    'budget_exceeded',
];
exports.REJECT_REASON_LABEL = {
    seen_url: 'Already seen this URL',
    republished: 'Identical content republished',
    source_disabled: 'Source disabled or blacklisted',
    stale: 'Too old to be news',
    listicle: 'Listicle or clickbait pattern',
    off_topic: 'Not AI-related',
    duplicate_event: 'Same event already covered',
    low_importance: 'Below the importance threshold',
    marketing: 'Marketing material, not news',
    unverified_claims: 'Claims could not be verified against the source',
    budget_exceeded: 'AI budget cap reached',
};
// --------------------------------------------------------------------- utils
/** Slug-safe string: lowercase, hyphenated, no punctuation. */
function slugify(input) {
    return input
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 80);
}
/**
 * Public URL path for a post, e.g. /en/models/claude-opus-5.
 *
 * Both locales carry an explicit prefix so neither is second-class and
 * hreflang stays symmetric. The slug is the English one in both languages:
 * an Arabic slug would percent-encode into unreadable URLs when shared.
 */
function postPath(category, slug, locale) {
    return `/${locale}/${exports.CATEGORY_PATH[category]}/${slug}`;
}
/** Locale-prefixed path for any route, e.g. localePath('/tools', 'ar'). */
function localePath(path, locale) {
    const clean = path === '/' ? '' : path.startsWith('/') ? path : `/${path}`;
    return `/${locale}${clean}`;
}
/**
 * Swap the locale on a path that already has one, preserving the rest.
 * Used by the language switcher so it lands on the same story.
 */
function switchLocalePath(pathname, target) {
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length > 0 && (0, i18n_1.isLocale)(segments[0])) {
        segments[0] = target;
        return `/${segments.join('/')}`;
    }
    return localePath(pathname, target);
}
